import React, { createContext, useContext } from "react";
import { lightTheme } from "./themeConfig";

const initialState = {
  isDark: false,
  toggleTheme: () => {},
  theme: lightTheme,
  themeKey: "light",
};

const ThemeContext = createContext(initialState);
export const useThemeContext = () => useContext(ThemeContext);

export const GlobalTheme = ({ children, isDark, theme, toggleIsDark }) => {
  const toggleTheme = () => {
    toggleIsDark(!isDark);
  };

  return (
    <ThemeContext.Provider
      value={{
        isDark,
        theme,
        toggleTheme,
        themeKey: isDark ? "dark" : "light", // Derive theme key here
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};
